import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { ActivityFilter, ActivityResponse } from '@core/models/activity.model';
import { ActivityService } from '@core/services/activity.service';

type ActivityState = {
  isLoading: boolean;
  activityRes: ActivityResponse;
};
const emptyData: ActivityResponse = {
  activities: [],
  numberOfItems: 0,
};

const initialState: ActivityState = {
  isLoading: false,
  activityRes: emptyData,
};

export const ActivityStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store, activityService = inject(ActivityService)) => ({
    getActivities: rxMethod<ActivityFilter>(
      pipe(
        tap(() => patchState(store, { isLoading: true })),
        switchMap(filter => {
          return activityService.getActivities(filter).pipe(
            tapResponse({
              next: data => {
                patchState(store, { activityRes: data, isLoading: false });
              },
              error: () => {
                patchState(store, { activityRes: emptyData, isLoading: false });
              },
            }),
          );
        }),
      ),
    ),
  })),
);
